import React from "react";

function EditDetails({ stroke = "#424242" }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 7.49994L18 10.4999M13 21.4999H21M5 17.4999L4 21.4999L8 20.4999L19.586 8.91394C19.9609 8.53889 20.1716 8.03027 20.1716 7.49994C20.1716 6.96961 19.9609 6.461 19.586 6.08594L19.414 5.91394C19.0389 5.539 18.5303 5.32837 18 5.32837C17.4697 5.32837 16.9611 5.539 16.586 5.91394L5 17.4999Z"
        stroke={stroke}
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default EditDetails;
